import React from 'react';
import { useTranslation } from 'react-i18next';
import { logger } from '@/infrastructure/logger';
import styles from './index.module.scss';

export const ComplianceBulletin = () => {
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const versionTipsString = params.get('versionTips');
  let versionTips = [];
  try {
    versionTips = versionTipsString ? JSON.parse(decodeURIComponent(versionTipsString)) : [];
  } catch (err) {
    logger.error('JSON error', err);
  }

  return (
  <div className={styles.page}>
    <div className={styles.container}>
      <div className={styles.title}>{t('Bugly SDK升级公告')}</div>
      <p className={styles.sub_title}>{t('尊敬的开发者：')}</p>
      <p className={styles.describe} style={{ marginBottom: 48 }}>
        {t('您好！为进一步优化 Bugly SDK 的功能体验，提升安全防护能力，并积极响应最新监管要求，我们对 Bugly SDK 进行了版本升级。请您及时关注并完成升级，以保障您的应用合规、安全运行。')}
      </p>
      <div className={styles.directory}>{t('一、最低合规 SDK 版本信息')}</div>
      <ul className={styles.ul}>
        <li className={styles.before_li}>
          {versionTips?.[0]?.split('\n')?.[0] || t('Android：4.4.3.3（2025年1月16日发布）')}
        </li>
        <li className={styles.li}>{versionTips?.[0]?.split('\n')?.[1] || t('去掉上报协议里面以“andorid id”命名的字段')}</li>
        <li className={styles.before_li}>{versionTips?.[1]?.split('\n')?.[0] || t('iOS：2.7.51（2023年6月25日发布）')}</li>
        <li className={styles.li}>{versionTips?.[1]?.split('\n')?.[1] || t('优化 idfv 获取逻辑')}</li>
      </ul>
      <div className={styles.directory}>{t('二、升级时间及影响')}</div>
      <p className={styles.describe} style={{ marginBottom: 16 }}>
      {t('请您务必及时将您 APP 中的 Bugly SDK 升级至上述或者更新的版本，以满足监管要求。若未及时升级，您的应用可能面临服务中断、强制下架、法律追责等风险。')}
      </p>
      <div className={styles.directory}>{t('三、升级指南')}</div>
      <p className={styles.describe}>
      {t('您可通过以下链接获取 SDK 最新版本、升级指南及个人信息处理规则，了解相关功能设置与配置方式。如有疑问，欢迎随时通过在线客服与我们联系。')}
      </p>
      <ul style={{ marginBottom: 48 }}>
        <li className={styles.before_li}>
          <a
            className={styles.link}
            target={'_blank'}
            href="https://privacy.qq.com/document/preview/693de0d2b30f4c9db6dfbcbfd6240e37"
          >
            {t('Bugly SDK个人信息处理规则')}
          </a>
        </li>
        <li className={styles.before_li}>
          <a
            className={styles.link}
            target={'_blank'}
            href="https://bugly.tds.qq.com/docs/sdk/ios/"
          >
            {t('Bugly SDK接入使用说明文档（iOS）')}
          </a>
        </li>
        <li className={styles.before_li}>
          <a
            className={styles.link}
            target={'_blank'}
            href="https://bugly.tds.qq.com/docs/sdk/android/"
          >
            {t('Bugly SDK接入使用说明文档（Android）')}
          </a>
        </li>
        <li className={styles.before_li}>
          <a
            className={styles.link}
            target={'_blank'}
            href="https://repo1.maven.org/maven2/com/tencent/bugly/bugly-pro/"
          >
            {t('Bugly SDK下载链接（Android）')}
          </a>
        </li>
        <li className={styles.before_li}>
          <a
            className={styles.link}
            target={'_blank'}
            href="https://github.com/BuglyDevTeam/BuglyPro-iOS/tree/main/release"
          >
            {t('Bugly SDK下载链接（iOS）')}
          </a>
        </li>
      </ul>
      <p className={styles.describe}>
        {t('感谢您一直以来的理解、信任与支持。我们高度重视个人信息保护，并将持续采用业界领先的安全措施，保障您的数据安全。')}
      </p>
      <div className={styles.name}>{t('Bugly 团队敬上')}</div>
    </div>
  </div>
  );
};
export default ComplianceBulletin;
